import { Component, Input, OnInit, OnDestroy } from '@angular/core';

import { GfTranslateService } from '../../../../services/core.translate.service';
import { StateService, TransitionService as UIRouterTransitionService, Transition } from '@uirouter/angular';
import { GfTitleService } from '../../../../services/core.title.service';

import { marker } from '../../../../services/ngx-translate-extract-marker';

@Component({
    selector: 'project-report-header',
    template: require('./project.report-header.component.html')
})
export class ProjectReportHeaderComponent implements OnInit, OnDestroy {

    @Input() project: any = null;
    @Input() projectMenu: any = null;

    protected selectedReport: string = null;
    private deregisterTransition: any = null;

    private routeTitleMap = {
        'home.project.summary.reports': marker('Summary'),
        'home.project.summary.reports.summary': marker('Summary'),
        'home.project.summary.reports.activity': marker('Activity'),
        'home.project.summary.reports.team': marker('Team'),
        'home.project.summary.reports.tracker': marker('Tracker'),
        'home.project.summary.reports.disk': marker('Disk Usage'),
        'home.project.summary.reports.scm': marker('SCM Commits'),
        'home.project.summary.reports.frs': marker('FRS Downloads'),
        'home.project.summary.reports.checks': marker('Health Checks')
    };

    constructor(
        private window: Window, 
        private gfTranslateService: GfTranslateService,
        private $transitions: UIRouterTransitionService,
        private stateService: StateService,
        private titleService: GfTitleService,
    ) { }
    
    ngOnInit() {
        // Set header based on current state
        this.setHeader(this.stateService.current.name);

        // Update header on successful state changes within reports subtree
        this.deregisterTransition = this.$transitions.onSuccess({ to: 'home.project.summary.reports.**' }, (transition: Transition) => {
            this.setHeader(transition.to().name);
        });
    }

    ngOnDestroy() {
        if (this.deregisterTransition) {
            this.deregisterTransition();
            this.deregisterTransition = null;
        }
    }

    setHeader(route) {
        this.selectedReport = this.getReportTitle(route);
        if (this.project && this.project.name) {
            this.titleService.setTitle(this.project.name, this.selectedReport);
        }
    }

    getReportTitle(route) {
        return this.gfTranslateService.translate(this.routeTitleMap[route] || '(unknown)');
    }
}